import { createSelector } from "@reduxjs/toolkit";
import { tableStyles } from "Constants/Style";
import CancelBackButton from "components/Buttons/CancelBackButton";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import FormattedDateTime from "components/FormattedDateTime/FormattedDateTime";
import LoadingSpinner from "components/LoaderErrorWrapper/LoadingSpinner";
import PageContainer from "components/PageContainer/PageContainer";
import TruncatedTextCell from "components/TruncatedTextCell/TruncatedTextCell";
import FilePreviewModal from "pages/Warehouse/ItemInward2/GRNDetails/FilePreviewModal/FilePreviewModal";
import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchIssueToLabourById } from "slices/Warehouse/Dispatch/IssueToLabour/thunk";
import ViewBagsModal from "./ViewBagsModal";

const IssueToLabourViewDetails: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();

  // Redux selectors
  const IssueToLabour = createSelector(
    (state: any) => state.IssueToLabour,
    (item) => ({
      selectedIssue: item.selectedIssue,
      loading: item.loading,
      error: item.error,
    })
  );
  const { selectedIssue: details, loading, error } = useSelector(IssueToLabour);

  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [showBagsModal, setShowBagsModal] = useState<boolean>(false);
  const [selectedItemBags, setSelectedItemBags] = useState<any[]>([]);
  const [selectedItemName, setSelectedItemName] = useState<string>("");

  useEffect(() => {
    console.log(id);
  }, [id]);

  useEffect(() => {
    if (id) {
      dispatch(fetchIssueToLabourById(id));
    }
  }, [id]);

  return (
    <>
      <PageContainer>
        <FormHeader
          title={"View Details"}
          firstLabel="Issue to Labour"
          secondLabel={"View Details"}
          handleArrowClick={() => navigate("/warehouse-dispatch")}
        />

        {loading ? (
          <LoadingSpinner />
        ) : (
          <div>
            <hr />
            <Row
              className="mb-2"
              style={{ marginLeft: "3px", marginTop: "2px" }}
            >
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Dispatch ID :</strong>{" "}
                  {details?.dispatch_number || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Dispatch Date :</strong>{" "}
                  <FormattedDateTime
                    dateString={details?.dispatch_date}
                    format="date-only"
                  />
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Dispatch By :</strong>{" "}
                  {details?.created_by_user?.username || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Labour Name:</strong>{" "}
                  {details?.labour?.labour_name || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Challan No. :</strong> {details?.challan_no || "-"}
                </p>
              </Col>
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Issue From :</strong>{" "}
                  {details?.issued_from_warehouse?.warehouse_name || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Document Uploaded :</strong>{" "}
                  {details?.document ? (
                    <button
                      onClick={() => setShowPreview(true)}
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                        padding: 0,
                        textDecoration: "underline",
                      }}
                    >
                      View
                    </button>
                  ) : (
                    "-"
                  )}
                  <FilePreviewModal
                    show={showPreview}
                    onClose={() => setShowPreview(false)}
                    url={details?.document}
                  />
                </p>
              </Col>
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Remark :</strong> {details?.remark || "-"}
                </p>
              </Col>
            </Row>
            <hr />
            <div className="mb-3">
              <h6
                className="mb-3"
                style={{ fontWeight: "600", color: "#212529" }}
              >
                Item Details
              </h6>
              <div className="mb-2">
                <Table hover responsive className="align-middle text-center">
                  <thead>
                    <tr>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "80px" }}
                      >
                        Sr No.
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Items
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Item Code
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Category
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Sub Category
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Unit
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Bag No.
                      </th>
                      {/* <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Total Quantity
                      </th> */}
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Dispatch Quantity
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Remarks
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {details?.dispatch_items?.length === 0 ? (
                      <tr>
                        <td
                          colSpan={17}
                          style={{ ...tableStyles.cell, textAlign: "center" }}
                          className="py-3"
                        >
                          No Items added.
                        </td>
                      </tr>
                    ) : (
                      details?.dispatch_items.map((row: any, idx: number) => {
                        return (
                          <tr key={idx}>
                            <td style={tableStyles.cell}>{idx + 1}</td>

                            {/* Items */}
                            <td style={tableStyles.cell}>
                              {row?.item_name || "-"}
                            </td>

                            {/* Item Code */}
                            <td style={tableStyles.cell}>
                              {row?.item_code || "-"}
                            </td>

                            {/* Category */}
                            <td style={tableStyles.cell}>
                              {row?.category?.category_name || "-"}
                            </td>

                            {/* Sub Category */}
                            <td style={tableStyles.cell}>
                              {row?.sub_category?.sub_category_name || "-"}
                            </td>

                            {/* Unit */}
                            <td style={tableStyles.cell}>
                              {row?.unit?.unit_name || row?.unit || "-"}
                            </td>

                            {/* Bag No. */}
                            <td style={tableStyles.cell}>
                              {row?.bags && row.bags.length > 0 ? (
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSelectedItemBags(row?.bags || []);
                                    setSelectedItemName(row?.item_name || "");
                                    setShowBagsModal(true);
                                  }}
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    textDecoration: "underline",
                                  }}
                                >
                                  View Bags ({row.bags.length})
                                </button>
                              ) : (
                                "-"
                              )}
                            </td>

                            {/* Bag Details Modal */}
                            <ViewBagsModal
                              show={showBagsModal}
                              handleClose={() => {
                                setShowBagsModal(false);
                                setSelectedItemBags([]);
                                setSelectedItemName("");
                              }}
                              bags={selectedItemBags}
                              itemName={selectedItemName}
                            />

                            {/* Total Quantity */}
                            {/* <td style={tableStyles.cell}>
                              {row?.total_quantity || "-"}
                            </td> */}

                            {/* Dispatch Quantity */}
                            <td style={tableStyles.cell}>
                              {row?.dispatch_quantity || "-"}
                            </td>
                            {/* Remarks */}
                            <td className="remark-cell" style={tableStyles.cell}>
                              <TruncatedTextCell
                                text={row?.remark}
                                maxWidth="300px"
                                maxLines={4}
                                rowIndex={idx}
                                fallbackText="-"
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="d-flex justify-content-center gap-3 py-3">
              <CancelBackButton
                label="Back"
                onClick={() => {
                  navigate("/warehouse-dispatch");
                }}
              />
            </div>
          </div>
        )}
      </PageContainer>
    </>
  );
};

export default IssueToLabourViewDetails;
